require('./bootstrap');
import Vue from 'vue';
import vuetify from './plugins/vuetify' // path to vuetify export

//importar el router
import router from './router'

//importar el vuex
import store from './store'

//importar los plugins
require('./plugins');

//componente inicial
Vue.component('app-component', require('./views/App').default);

const app = new Vue({
    vuetify,
    router,
    store,
    el: '#app',

}).$mount('#app');
// import {Workbox} from 'workbox-window';
// if ('serviceWorker' in navigator) {
//   const wb = new Workbox('/service-worker.js');
//
//   wb.register();
// }
